import type {BrandLogoResource} from '../types/imageResources';
import type {IGatsbyImageData} from 'gatsby-plugin-image';

export type BrandLogoQueryResult = {
  readonly file: {
    readonly childImageSharp: {
      readonly gatsbyImageData: IGatsbyImageData;
    } | null;
  } | null;
};

export const resolveBrandLogoResource = (data: BrandLogoQueryResult): BrandLogoResource => {
  const gatsbyImageData = data.file?.childImageSharp?.gatsbyImageData;

  if (!gatsbyImageData) {
    throw new Error(`Brand logo image data is missing. Ensure logo-square.png is available to Gatsby.`);
  }

  const fallbackSrc = gatsbyImageData.images.fallback?.src ?? gatsbyImageData.images.sources?.[0]?.srcSet?.split(` `)[0] ?? null;

  if (!fallbackSrc) {
    throw new Error(`Unable to derive fallback src for the brand logo image.`);
  }

  return {
    gatsbyImageData,
    src: fallbackSrc,
    placeholderSrc: gatsbyImageData.placeholder?.fallback ?? null,
  };
};
